import React from 'react';
import {
  Box,
  TextField,
  Grid
} from '@mui/material';
import type { Person } from '../../../../types';

interface BiographyFormProps {
  data: Partial<Person>;
  errors: Record<string, string>;
  onChange: (field: string, value: any) => void;
  disabled?: boolean;
}

/**
 * BiographyForm - Edit biographical information
 *
 * Fields:
 * - Biography (multiline)
 * - Personal Notes (multiline)
 * - Achievements (one per line)
 */
export const BiographyForm: React.FC<BiographyFormProps> = ({
  data,
  errors,
  onChange,
  disabled = false
}) => {
  return (
    <Box sx={{ pt: 2 }}>
      <Grid container spacing={3}>
        {/* Biography */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={6}
            label="Biography"
            value={data.biography || ''}
            onChange={(e) => onChange('biography', e.target.value)}
            error={!!errors.biography}
            helperText={errors.biography || 'Write a detailed biography of this person'}
            disabled={disabled}
          />
        </Grid>

        {/* Personal Notes */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Personal Notes"
            value={data.personalNotes || ''}
            onChange={(e) => onChange('personalNotes', e.target.value)}
            error={!!errors.personalNotes}
            helperText={errors.personalNotes || 'Private notes for research purposes'}
            disabled={disabled}
          />
        </Grid>

        {/* Achievements */}
        <Grid item xs={12}>
          <TextField
            fullWidth
            multiline
            rows={4}
            label="Achievements"
            value={
              Array.isArray(data.achievements)
                ? data.achievements.join('\n')
                : data.achievements || ''
            }
            onChange={(e) => onChange('achievements', e.target.value.split('\n').map(a => a.trim()).filter(Boolean))}
            error={!!errors.achievements}
            helperText={errors.achievements || 'List achievements, one per line'}
            disabled={disabled}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
